import axios from 'axios'

const state = {
  companies: [],
  totalCount: 0
}

const mutations = {
  setCompanies (state, { companies, totalCount }) {
    state.companies = companies
    state.totalCount = totalCount
  }
}

const actions = {
  getCompanies ({ rootState }, request) {
    const callerCompanyId = rootState.userCurrentCompany && rootState.userCurrentCompany.companyId
    return axios.get(`/api/company/${callerCompanyId}/admin/companies`, { params: request })
  },

  getCompanyForAdminEdit ({ rootState }, companyId) {
    const callerCompanyId = rootState.userCurrentCompany && rootState.userCurrentCompany.companyId
    return axios.get(`/api/company/${callerCompanyId}/admin/companies/${companyId}`)
  },

  saveCompanyAdminInfo ({ rootState }, { companyId, request }) {
    const callerCompanyId = rootState.userCurrentCompany && rootState.userCurrentCompany.companyId
    return axios.post(`/api/company/${callerCompanyId}/admin/companies/${companyId}/save`, request)
  },

  cloneCompany ({ rootState }, request) {
    const callerCompanyId = rootState.userCurrentCompany && rootState.userCurrentCompany.companyId
    return axios.post(`/api/company/${callerCompanyId}/admin/companies/clone`, request)
  },

  getCompaniesList ({ rootState }) {
    const callerCompanyId = rootState.userCurrentCompany && rootState.userCurrentCompany.companyId
    return axios.get(`/api/company/${callerCompanyId}/admin/companies`, {
      params: { page: 1, pageSize: 500, sortBy: 'name', sortDirection: 'asc' }
    })
  },

  deleteCompany ({ rootState }, targetCompanyId) {
    const callerCompanyId = rootState.userCurrentCompany && rootState.userCurrentCompany.companyId
    return axios.delete(`/api/company/${callerCompanyId}/admin/companies/${targetCompanyId}`)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/adminCompanies.js